import { array, object, string } from "yup";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { teachingMethodologiesArraySchema } from "@shared-kernel/primary/shared/teaching-methodologies-field/teaching-methodologies-field.schema";
import type { TeachingMethodology } from "@academy-context/shared/domain/types/enums/teaching-methodology";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { TeacherVM, UpdateTeacherTeachingBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const URL_INVALID = "URL invalide";
export const CERTIFICATIONS_MIN_ERROR = "Au moins une certification est requise";

export interface TeacherPedagogyFormInputs {
  teacherResumeUrl: string;
  artistResumeUrl: string;
  certifications: string[];
  teachingMethodologies: TeachingMethodology[];
}

export const teacherPedagogyDefaultValues: TeacherPedagogyFormInputs = {
  teacherResumeUrl: "",
  artistResumeUrl: "",
  certifications: [],
  teachingMethodologies: [],
};

export const teacherPedagogySchemaShape = {
  teacherResumeUrl: string().required(REQUIRED_FIELD).url(URL_INVALID),
  artistResumeUrl: string().url(URL_INVALID).defined(),
  certifications: array(string().trim().required(REQUIRED_FIELD))
    .transform((value, original) => (original == null ? [] : value))
    .min(1, CERTIFICATIONS_MIN_ERROR)
    .required(CERTIFICATIONS_MIN_ERROR),
  teachingMethodologies: teachingMethodologiesArraySchema,
};

export const teacherPedagogySchema = object().shape(teacherPedagogySchemaShape);

export const formatTeacherDataToPedagogyFormData = (teacher: TeacherVM): TeacherPedagogyFormInputs => ({
  teacherResumeUrl: teacher.teacherResumeUrl ?? "",
  artistResumeUrl: teacher.artistResumeUrl ?? "",
  certifications: teacher.certifications,
  teachingMethodologies: teacher.teachingMethodologies,
});

const emptyToNull = (value: string): Nullable<string> => (value.trim() === "" ? null : value);

export const formatPedagogyFormDataToBody = (data: TeacherPedagogyFormInputs): UpdateTeacherTeachingBody => ({
  teacherResumeUrl: data.teacherResumeUrl,
  artistResumeUrl: emptyToNull(data.artistResumeUrl),
  certifications: data.certifications,
  teachingMethodologies: data.teachingMethodologies,
});
